import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { CarRequestComponent } from "../custom-services/components/car-request/car-request.component";

const routes: Routes = [{ path: "", component: CarRequestComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CarRoutingModule {}
